import Login from './Login'
import Home from './Home'
import Attendance from './Attendance'
import Info from './Info'
import LoginInfo from './LoginInfo'
import Checkin from './Checkin'
import CheckinSuccess from './CheckinSuccess'
import RegisterWFH from './RegisterWFH'
import RiskAssessment from './RiskAssessment'
// import RiskAssessmentCovidTest from './RiskAssessmentCovidTest'
import LoginRisk from './LoginRisk'
import RegisterCovid from './RegisterCovid'
import MenuCovid from './MenuCovid'
import MenuReport from './MenuReport'
import Report from './Report'
import AssessmentHistory from './AssessmentHistory'
import CovidCheckHistory from './CovidCheckHistory'
import VaccinHistory from './VaccinHistory'
import SignUpForHelp from './SignUpForHelp'
import CheckinHistory from './CheckinHistory'
import CovidAddHelp from './CovidAddHelp'
import RegisterCovidShow from './RegisterCovidShow'
import CheckINOffice from './CheckINOffice'
import RIskAssessmentOffice from './RIskAssessmentOffice'
import Leave from './Leave'
import LeavePrivilege from './LeavePrivilege'
import LeaveHistory from './LeaveHistory'
import Privacy from './Privacy'
import ShiftsTransfer from './ShiftsTransfer'
import ShiftsTransferRichmenu from './ShiftsTransferRichmenu'
import LoginShiftTransfer from './LoginShiftTransfer'
import Team from './Team'
import OTRequest from './OTRequest'
import News from './News'
import NewsVgroup from './NewsVgroup'
import NewsToKnow from './NewsToKnow'
import NewsLatestNews from './NewsLatestNews'
import NewsToActivity from './NewsToActivity'
import HomeEvent from './HomeEvent'
import EmpFamily from './EmpFamily'
import EmpAddress from './EmpAddress'
import RegisterEvent from './RegisterEvent'
import EmpInfomation from './EmpInfomation'
import AdjustCheckInCheckOut from './AdjustCheckInCheckOut'
import GetLocation from './GetLocation'
import IssueProblem from './IssueProblem'
import IssueProblemCars from './IssueProblemCars'
import HomeWelfare from './HomeWelfare'
import HomeSpecialRequest from './HomeSpecialRequest'
import HomeEmployee from './HomeEmployee'
import SocialInsurance from './SocialInsurance'
import GroupInsurance from './GroupInsurance'
import RequestDoc from './RequestDoc'
import ManualApp from './ManualApp'
import WelfareMarriage from './WelfareMarriage'
import WelfareMaternity from './WelfareMaternity'
import WelfareFuneral from './WelfareFuneral'
import WelfareTravelExpenses from './WelfareTravelExpenses'
import WelfareDiscountSpareParts from './WelfareDiscountSpareParts'
import WelfareDiscountWage from './WelfareDiscountWage'
import welfareDiscountAccessories from './welfareDiscountAccessories'
import QuestionnaireTrain from './QuestionnaireTrain'
import QuestSuccess from './QuestSuccess'
import WelfareHistory from './WelfareHistory'
import WelfareHistoryHR from './WelfareHistoryHR'
import WelfareHistoryBranch from './WelfareHistoryBranch'
import EmployeeAddHelp from './EmployeeAddHelp'
import QuestionHistory from './QuestionHistory'
import WelfareHistoryEmp from './WelfareHistoryEmp'
import ShiftWorkEmp from './ShiftWorkEmp'

export default {
  Home,
  Attendance,
  Login,
  Checkin,
  CheckinSuccess,
  RegisterWFH,
  Info,
  LoginInfo,
  RiskAssessment,
  LoginRisk,
  RegisterCovid,
  MenuCovid,
  MenuReport,
  Report,
  AssessmentHistory,
  CovidCheckHistory,
  VaccinHistory,
  SignUpForHelp,
  CheckinHistory,
  CovidAddHelp,
  RegisterCovidShow,
  CheckINOffice,
  Leave,
  LeavePrivilege,
  LeaveHistory,
  Privacy,
  // RiskAssessmentCovidTest,
  RIskAssessmentOffice,
  ShiftsTransfer,
  ShiftsTransferRichmenu,
  LoginShiftTransfer,
  Team,
  OTRequest,
  News,
  NewsVgroup,
  NewsToKnow,
  NewsLatestNews,
  NewsToActivity,
  HomeEvent,
  EmpFamily,
  RegisterEvent,
  EmpAddress,
  EmpInfomation,
  AdjustCheckInCheckOut,
  GetLocation,
  IssueProblem,
  IssueProblemCars,
  HomeSpecialRequest,
  HomeWelfare,
  HomeEmployee,
  SocialInsurance,
  GroupInsurance,
  RequestDoc,
  ManualApp,
  WelfareMarriage,
  WelfareMaternity,
  WelfareFuneral,
  WelfareTravelExpenses,
  WelfareDiscountSpareParts,
  WelfareDiscountWage,
  welfareDiscountAccessories,
  QuestionnaireTrain,
  QuestSuccess,
  WelfareHistory,
  WelfareHistoryHR,
  WelfareHistoryBranch,
  EmployeeAddHelp,
  QuestionHistory,
  WelfareHistoryEmp,
  ShiftWorkEmp
}



// WEBPACK FOOTER //
// ./src/components/Liff/index.js